import numeral from "numeral";
import dayjs from "dayjs";

export const CompanyCode = process.env.REACT_APP_COMPANY_CODE || "0000"

// 환경변수에서 API 호스트 설정 가져오기
// .env.XXXX 파일에서 REACT_APP_API_HOST, REACT_APP_WS_HOST 설정 가능
// 환경변수가 없으면 NODE_ENV에 따라 기본값 사용:
export const apiHost = process.env.REACT_APP_API_HOST || (process.env.NODE_ENV === 'production'
    ? "https://api-prod.oo-onesolution.com" 
    : "https://api-dev.oo-onesolution.com")
export const wsHost = process.env.REACT_APP_WS_HOST || (process.env.NODE_ENV === 'production' 
    ? "wss://api-prod.oo-onesolution.com/ws" 
    : "wss://api-dev.oo-onesolution.com/ws")

export function currencyFormatter(params) {
    return numeral(params.value).format("0,0");
}

export function dateFormatter(params, format) {
    return dayjs(params.value).format(format);
}

export const defaultColDef = {
    width: 100,
    resizable: true,
    sortable: true,
    filter: false,
    suppressSizeToFit: true,
    suppressMenu: true,
    suppressHeaderMenuButton: true,
    autoHeaderHeight: true
}

export const resultBoolean = (value) => {
    return value === 1 || value === '1'
}

export function convertBoolean(value) {
    // 숫자 0을 false로 변환
    if (value === 0) {
        return false;
    }

    // 숫자 1을 true로 변환
    if (value === 1) {
        return true;
    }

    // 불리언 true를 1로 변환
    if (value === true) {
        return 1;
    }

    // 불리언 false를 0으로 변환
    if (value === false) {
        return 0;
    }

    // 입력값이 0, 1, true, false가 아닐 경우 null 반환
    return null;
}

export function exportInOut(type) {
    switch (type) {
        case "I": return "지급"
        case "O": return "출금"
    }
}

export function exportPointDiv(type) {
    switch (type) {
        case "bet": return "베팅"
        case "fee": return "롤링"
        case "admin_point_in":
            return "관리자포인트지급"
        case "admin_money_in":
            return "관리자머니지급"
        case "admin_point_out":
            return "관리자포인트회수"
        case "admin_money_out":
            return "관리자머니회수"
        case "win": return "당첨"
        case "draw": return "적특"
        case "deposit": return "충전"
        case "withdraw": return "환전"
        case "deposit_cancel": return "충전취소"
        case "exchange": return "포인트전환"
    }
}

export function exportGameDiv(gameDiv) {
    switch (gameDiv) {
        case "sport": return "스포츠"
        case "minigame": return "미니게임"
        case "casino": return "카지노"
        case "slot": return "슬롯"
        case "none": return "미선택"
        default: return ""
    }
}

export function exportUserStatus(status) {
    switch (status) {
        case 0: return "요청"
        case 1: return "정상"
        case 2: return "정지"
        case 3: return "탈퇴"
        case 8: return "테스트"
        case 9: return "요청"
    }
}

export function exportExchangeStatus(status) {
    switch (status) {
        case 0: return "요청"
        case 1: return "대기"
        case 4: return "취소"
        case 8: return "거절"
        case 9: return "완료"
    }
}

export function exportUseYn(useYn) {
    switch (useYn) {
        case 0: return "미사용"
        case 1: return "사용"
    }
}

export function exportSportBettingType(bettingType) {
    switch (bettingType) {
        case 'normal': return "조합베팅"
        case 'special': return "스페셜"
        case 'inplay': return "인플레이"
        default: return ""
    }
}

/**
 * 경기명 치환
 */
export const changeSportName = (sportCode) => {
    let sportName = ""
    switch (sportCode) {
        case 'soccer':
            sportName = "축구"
            break;
        case 'esports':
            sportName = "E스포츠"
            break;
        case 'baseball':
            sportName = "야구"
            break;
        case 'basketball':
            sportName = "농구"
            break;
        case 'volleyball':
            sportName = "배구"
            break;
        case 'tabletennis':
            sportName = "탁구"
            break;
        case 'tennis':
            sportName = "테니스"
            break;
        case 'icehockey':
            sportName = "하키"
            break;
        case 'americanfootball':
            sportName = "미식축구"
            break;
        case 'boxingufc':
            sportName = "UFC/복싱"
            break;
        case 'handball':
            sportName = "핸드볼"
            break;
        default:
            sportName = sportCode
            break;
    }
    return sportName
}

export function isMobile(userAgent) {
    return /Mobi|Android|iPhone|iPad|iPod/i.test(userAgent);
}

export function exportGameType(gameType) {
    switch (gameType) {
        case 'sport': return "스포츠"
        case 'minigame': return "미니게임"
        case 'casino': return "카지노"
        case 'slot': return "슬롯"
        default: return ""
    }
}